module.exports = __webpack_public_path__ + "static/media/cielo.b53c80e2.jpg";